<template>
    <div class="movie-box acea-row row-between-wrapper wrap-comp text-size">
        <p class="page-margin-right2 tainfor">{{name}}:</p>
        <div class="tainfor-box">
            <!-- 文本 -->
            <div v-if="type == 4 || type == 5">
                <input class="text-input" type='text' placeholder="请填写" required v-model.trim="value"/>
            </div>
            <!-- 单选 -->
            <div v-if="type == 1 || type == 3">
                <div v-for="(item, ind) in list" :key="ind" @click="singleChoice(item)">
                    <span class="page-inline-block page-margin-right2 rol" :class="{'check-rol': item.ResourceOrderExtendInfoItemID === singleChoice_val.ResourceOrderExtendInfoItemID}"></span> {{item.Content}}
                </div>
            </div>
            <!-- 多选 -->
            <div v-if="type == 2">
                <div v-for="(item, ind) in multipleChoicelist" :key="ind" @click="multipleChoice(item)">
                    <span class="page-inline-block page-margin-right2 rol2" :class="{'check-rol': item.isShow}"></span> {{item.Content}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TicketAdditionalInfor",
    data: function () {
        return {
            value: "", //文本值
            singleChoice_val: {//单选值
                ResourceOrderExtendInfoItemID: null,
                value: ""
            },
            multipleChoicelist: []
        }
    },
    props: {
        name: "",
        all: {
            type: Object,
            default: ()=>{}
        },
        type: {
            type: Number,
            default: 4
        }, //文本 ---1单选 2多选 4文本
        list: {
            type: Array,
            default: ()=>[ //列表
                {
                    Content: "",
                    ResourceOrderExtendInfoItemID: null,
                    isShow: false
                }
            ]
        }
    },
    watch: {
        value: {
            handler: function (newVal) {
                if (!newVal) return;
                let alldata = {
                    ...this.all,
                    value: [ {value: newVal, id: null}]
                };
                this.$emit('value', alldata);
            }
        },
        singleChoice_val: {
            handler: function (newVal) {
                let alldata = {
                    ...this.all,
                    value: [ {value: newVal.value, id: newVal.ResourceOrderExtendInfoItemID}]
                };
                this.$emit('value', alldata);
            },
            deep: true,
            immediate: true
        },
        list: {
            handler: function (newVal) {
                let list = newVal;
                list && list.forEach((item)=>{
                    item.isShow  = false;
                });
                this.multipleChoicelist = list;
            },
            immediate: true,
            deep: true
        },
        multipleChoicelist: {
            handler: function (newVal) {
                let new_list = [];
                newVal && newVal.forEach((item)=>{
                    if (item.isShow) {
                        new_list.push(item);
                    };
                });
                let arr = [];
                new_list && new_list.forEach((val)=>{
                    arr.push({
                        value: val.Content,
                        id: val.ResourceOrderExtendInfoItemID
                    });
                })
                let alldata = {
                    ...this.all,
                    value: arr
                };
                this.$emit('value', alldata);
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        singleChoice: function (val) {
            this.singleChoice_val = {
                ResourceOrderExtendInfoItemID: val.ResourceOrderExtendInfoItemID,
                value: val.Content
            };
        },
        multipleChoice: function (val) {
            let _multipleChoicelist = this.multipleChoicelist;
            _multipleChoicelist.forEach((item,ind)=>{
                if (val.ResourceOrderExtendInfoItemID == item.ResourceOrderExtendInfoItemID) {
                    item.isShow = !item.isShow;
                }
            });
            this.multipleChoicelist = JSON.parse(JSON.stringify(_multipleChoicelist));
        }
    }
}
</script>

<style scoped>
.tainfor {
    width: 1.5rem;
    overflow: hidden;
}
.tainfor-box {
    width: 70%;
    overflow: hidden;
}
.text-input {
    height: .46rem;
    width: 100%;
}
.rol {
    width: .3rem;
    height: .3rem;
    border-radius: 50%;
    border: .02rem solid lightblue;
}
.rol2 {
    width: .3rem;
    height: .3rem;
    border: .02rem solid lightblue;
}
.check-rol {
    background: lightblue;
}
.text-size { 
    font-size: .32rem;
}
.wrap-comp {
    flex-wrap: nowrap;
    align-items: flex-start;
}
</style>